import Link from 'next/link';

import type { Post } from '@/types';
import { getReadingTime } from '@/lib/mdx';

interface Props {
  post: Post;
}

export const PostListItem = ({ post }: Props) => {
  const readingTime = getReadingTime(post.content);

  return (
    <article key={post._id} className="border-b-2 border-b-gray-100">
      <div className="flex justify-between items-end">
        <h3 className="mb-0">
          <Link href={`/post/${post.slug.current}`}>
            <a className="no-underline lowercase link__gradient">
              {post.title}
            </a>
          </Link>
        </h3>
        <span className="text-sm text-gray-600">{readingTime}</span>
      </div>
      <p className="mt-[.5em]">{post.description}</p>
    </article>
  );
};
